import { UserStub } from "api/common/types/auth.types";
import { TDateISO } from "api/common/types/datetime.types";
import { valueof } from "api/common/utils/type.utils";

export interface FilesPayload {
  file_type: string; //these might all be enums?
  file_type_id: string | number;
  file_source_type?: string;
}

export const FILE_TYPES = {
  ADDENDA: "Addenda",
  CC_CERTIFICATE: "CC Certificate",
  CONTROL_MAPPINGS: "Control Mappings",
  DOD_ANNEXES: "DoD Annexes",
  MOBILE_APPLICATION_VETTING: "Mobile Application Vetting",
  OTHER: "Other",
  PP_CONFIGURATION: "PP Configuration",
  PROTECTION_PROFILES: "Protection Profiles",
  PROTECTION_PROFILE_HTML: "Protection Profile (HTML)",
  SUPPORTING_DOCUMENTS: "Supporting Documents",
  TABULAR_FORMS: "Tabular Forms",
  USAGE_GUIDANCE: "Usage Guidance",
  VALIDATION_REPORT: "Validation Report",
} as const;
export type FileType = valueof<typeof FILE_TYPES>;

export const FILE_VISIBILITY_TYPES = {
  PUBLIC: "Public",
  PROPRIETARY: "Proprietary",
};

export type FileVisibility = valueof<typeof FILE_VISIBILITY_TYPES>;
interface FileBase {
  file_id: number;
  file_name: string;
  file_type_id: number;
  file_type: FileType;
}
export interface FileUploadObject {
  active: boolean;
  file_display_name: string;
  file_label: string;
  file_name: string;
  file_source_type: "Assurance Maintenance" | null; // not 100% sure on this one but its in the code like this
  file_type: FileType;
  file: File;
  private: boolean;
}

export interface UserUploadedFile extends FileBase {
  active: boolean;
  approved: boolean;
  ccid?: null; // not sure what this is supposed to be
  file_display_name: string;
  file_label: string;
  file_location: string;
  file_mime_type: string;
  file_new_name: string;
  file_source_type: string;
  isFolder: boolean;
  parent: FileBase;
  private: boolean;
  published: boolean;
  removed_by: UserStub | null;
  removed_on: TDateISO | null;
  replaced_by: UserStub | null;
  replaced_on: TDateISO | null;
  replaced: boolean;
  retracted: boolean;
  uploaded_by: UserStub;
  uploaded_on: TDateISO;
}
